// Ce que le client a souscrit, pour l'affichage seulement.
//
// LE MASQUAGE N'EST PAS LA PROTECTION. C'est `exiger_module` cote serveur qui
// refuse : ici on evite simplement de proposer une porte fermee. Un ecran qui
// affiche un bouton repondant 403 donne l'impression d'un logiciel casse
// plutot que d'une option non souscrite.
//
// Le Parc n'apparait pas : il est toujours actif, tout le reste s'y accroche.
import { useEffect, useState } from "react";

import api from "./api";

// Valeurs de repli : TOUT ACTIF. Si l'appel echoue, mieux vaut afficher un
// ecran qui repondra 403 que masquer une fonction souscrite -- le premier se
// comprend et se signale, le second passe pour une disparition inexpliquee.
const PAR_DEFAUT = {
  lecture_factures: false,   // sauf celle-ci : payante, donc jamais par defaut
  module_vgp: true,
  module_operations: true,
  // Le Stock suit la meme regle de repli que les autres : on prefere un ecran
  // qui repondra 403 a une fonction souscrite qu'on aurait fait disparaitre.
  module_stock: true,
  module_financement: true,
  // Module NEUF, coupé chez la quasi-totalité des clients : comme la lecture de
  // factures, jamais actif par défaut. Le repli optimiste afficherait un bouton
  // menant à un 403.
  module_location: false,
  // Celui-ci fait exception, comme la lecture de factures : en cas d'echec de
  // l'appel, on ne propose PAS d'ouvrir un compte. Le repli optimiste
  // afficherait un bouton menant a un 403 chez la quasi-totalite des clients,
  // pour qui la creation passe par l'editeur.
  gestion_comptes_client: false,
};

// Mise en cache le temps de la session : le menu et les fiches interrogent
// tous la meme chose, et cette reponse ne change pas en cours de navigation.
let cache = null;

export function reinitialiserModules() {
  cache = null;
}

export function useModules() {
  const [modules, setModules] = useState(cache || PAR_DEFAUT);
  const [charge, setCharge] = useState(cache !== null);

  useEffect(() => {
    if (cache) return;
    let vivant = true;
    api
      .get("/mes-options")
      .then(({ data }) => {
        cache = { ...PAR_DEFAUT, ...data };
        if (vivant) {
          setModules(cache);
          setCharge(true);
        }
      })
      .catch(() => {
        if (vivant) setCharge(true);   // on garde le repli « tout actif »
      });
    return () => {
      vivant = false;
    };
  }, []);

  return { ...modules, charge };
}
